import React, { Component } from 'react'
import event1 from './../assets/event1.jpg';
import Tropical from './../assets/Tropical.jpeg';
import Teaser from './../assets/stellarVid.mp4';
import Stellar from './../assets/stellar.jpg';
import Anni from './../assets/CosmicAnni.jpeg';

export default class Events extends Component {
    componentDidMount(){
        const script = document.createElement("script");
        
        script.src = "https://assets.ticketinghub.com/checkout.js";
        script.setAttribute("data-widget","0d482d44-728a-4858-8ed7-9401ddc74434")
        script.async = true;
        document.querySelector('#TicketButton').appendChild(script);
    }
    render() {
        return (            
            <div style={{ display: 'flex', flex: 1, width: "100vw" }}>
            <div className="List">
            <div className="EventCard">
                <div class="box">
</div>
                    <a href="https://www.facebook.com/events/1150662078656358/" target="_blank">
                                     
                        <img className="EventPic" src={Anni}></img>
                    </a>
                            <div className="EventDetail">
                                <h3><a style={{ justifySelf: 'center' }} href="https://www.facebook.com/events/1150662078656358/" target="_blank">
                                Cosmic Moon's first anniversary <br>
                                </br><br></br> @The Box
                            </a>
                                </h3>
                                 <br></br>
        </div>
                        <div id="TicketButton"></div>
                </div>

            <div className="EventCard">
                <div class="box">
                <div class="box">
   <div class="ribbon"><span>Passed</span></div>
</div>
</div>
                    <a href="https://www.facebook.com/events/617084392105481" target="_blank">
                                     
                        <img className="EventPic" src={Stellar}></img>
                    </a>
                            <div className="EventDetail">
                                <h3><a style={{ justifySelf: 'center' }} href="https://www.facebook.com/events/617084392105481" target="_blank">
                                Stellar Nights Episode 2 by Cosmic Moons @The Box
                            </a>
                                </h3>
                                The Moons are aligning  <br></br>

        </div>
                            <br /><br></br>
                </div>

                <div className="EventCard">
                <div class="box">
   <div class="ribbon"><span>Passed</span></div>
</div>
                    <a href="https://www.facebook.com/events/377750756192456" target="_blank">
                                     
                        <img className="EventPic" src={Tropical}></img>
                    </a>
                            <div className="EventDetail">
                                <h3><a style={{ justifySelf: 'center' }} href="https://www.facebook.com/events/377750756192456" target="_blank">
                                    Summer Jam by Cosmic Moons @Maison Balkii
                            </a>
                                </h3>
                                Come and groove on our summer jams at  Maison Balkii ! <br></br>

        </div>
                            <br /><br></br>
                        
                </div>

                <div className="EventCard">

                    <div >
                    <div class="box">
   <div class="ribbon"><span>Passed</span></div>
</div>
                        <video className="EventPic" controls poster={event1}>
                            <source src={Teaser} type="video/mp4"/>
                                    Your browser does not support the video tag.
</video>
                    </div>
                            <div className="EventDetail">
                                <h3><a style={{ justifySelf: 'center' }} href="https://www.facebook.com/events/289730374964956/" target="_blank">
                                    Stellar Nights by Cosmic Moons @105 Voisins
                            </a>
                                </h3>
                                Cosmic Moons is landing for its first edition on the rooftop of 105 Voisins in Geneva ! Come and discover a one of a kind vibe !
        </div>
                            <br /><br></br>
                            <a style={{ justifySelf: 'flex-end' }} href="https://www.facebook.com/events/289730374964956/" target="_blank">Click here to read more on facebook</a>
        </div>
                    </div>
                    </div>

                    )
                }
}


// WEBPACK FOOTER //
// ./src/components/Events.js